import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import VehicleSaleForecast from './index';
import MaintainSaleForecast from './maintain';

export const vehicleSaleForecastRoutes = [
  {'component': <VehicleSaleForecast />, 'path': paths.VehicleSaleForecast},
  {'component': <MaintainSaleForecast />, 'path': paths.MaintainSaleForecast},
];
